import { render, staticRenderFns } from "./ItemLote.vue?vue&type=template&id=e13856d8&"
import script from "./ItemLote.vue?vue&type=script&lang=js&"
export * from "./ItemLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports